import { createTheme } from "@mui/material";
import { interfaceColors as colors } from "./interfaceColors";

export const gameTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: colors.action,
      light: colors.actionBorder,
      contrastText: colors.text
    },
    secondary: { main: colors.focus, contrastText: colors.background },
    background: { default: colors.background, paper: colors.panel },
    text: { primary: colors.text, secondary: colors.secondaryText },
    divider: colors.border
  },
  typography: {
    fontFamily: "Roboto, sans-serif",
    button: { textTransform: "none", fontWeight: 700 }
  },
  components: {
    MuiSwitch: {
      styleOverrides: {
        root: { height: 44 },
        switchBase: { minWidth: 44, minHeight: 44 }
      }
    },
    MuiButton: {
      defaultProps: { disableElevation: true, disableFocusRipple: true },
      styleOverrides: {
        root: { minHeight: 44 },
        containedPrimary: {
          border: `2px solid ${colors.actionBorder}`,
          "&:hover": { backgroundColor: colors.action }
        },
        outlinedPrimary: {
          color: colors.actionBorder,
          borderColor: colors.actionBorder
        },
        textPrimary: { color: colors.actionBorder }
      }
    },
    MuiInputBase: { styleOverrides: { root: { minHeight: 48 } } },
    MuiInputLabel: {
      styleOverrides: {
        root: { "&.Mui-focused": { color: colors.actionBorder } }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: colors.actionBorder
          }
        }
      }
    },
    MuiPaper: { styleOverrides: { root: { backgroundImage: "none" } } },
    MuiDialog: {
      styleOverrides: {
        paper: { border: `1px solid ${colors.border}`, borderRadius: 12 }
      }
    },
    MuiPopover: {
      styleOverrides: {
        paper: { border: `1px solid ${colors.border}`, borderRadius: 12 }
      }
    },
    MuiIconButton: {
      styleOverrides: { root: { minWidth: 44, minHeight: 44 } }
    },
    MuiButtonBase: {
      styleOverrides: {
        root: {
          "&.Mui-focusVisible": {
            outline: `3px solid ${colors.focus}`,
            outlineOffset: 3
          }
        }
      }
    }
  }
});

export const gamePanelSx = {
  p: { xs: 1.5, sm: 3 },
  border: `1px solid ${colors.border}`,
  borderRadius: 3,
  bgcolor: colors.panel,
  minWidth: 0
} as const;

export const gameSummarySx = {
  cursor: "pointer",
  minHeight: 48,
  display: "flex",
  alignItems: "center",
  gap: 1.5,
  px: 1.5,
  py: 1,
  fontWeight: 700,
  listStyle: "none",
  border: `1px solid ${colors.actionBorder}`,
  borderRadius: 1.5,
  bgcolor: colors.actionSurface,
  "&::-webkit-details-marker": { display: "none" },
  "&::after": {
    content: '""',
    width: 8,
    height: 8,
    flexShrink: 0,
    ml: "auto",
    mr: 0.5,
    borderRight: `2px solid ${colors.actionBorder}`,
    borderBottom: `2px solid ${colors.actionBorder}`,
    transform: "rotate(-45deg)"
  },
  "&:hover": { bgcolor: colors.atmosphere },
  "&:focus-visible": { outline: `3px solid ${colors.focus}`, outlineOffset: 3 }
} as const;
